<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">A Sensory History of Ancient Warfare</h1>
<p class="titlea">Reconstructing the Physical Experience of War in the Classical World</p>
<p class="author">Conor Whately</p>
<div class="image_container">
<img alt="images" src="images/p0iii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?626bb5ba